(() => {
  if (window.vivaExperienceReady) return;
  window.vivaExperienceReady = true;
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-viva-menu-open]');
    if (opener) document.getElementById(opener.dataset.vivaMenuOpen)?.showModal();
    const closer = event.target.closest('[data-viva-menu-close]');
    if (closer) closer.closest('dialog')?.close();
    document.querySelectorAll('.v-navigation--desktop details[open]').forEach(detail => {
      if (!detail.contains(event.target)) detail.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.v-navigation--desktop details[open]').forEach(detail => { detail.open = false; detail.querySelector('summary')?.focus(); });
  });
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const animations = new Set();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      if (reduced.matches) return;
      const animation = entry.target.animate([{transform:'translateY(14px)'},{transform:'translateY(0)'}],{duration:520,easing:'cubic-bezier(.22,1,.36,1)'});
      animations.add(animation);animation.finished.then(()=>animations.delete(animation),()=>animations.delete(animation));
    });
  },{threshold:.12});
  function register(root=document){root.querySelectorAll('[data-viva-reveal], .viva-brands, .viva-all-brands, .v-card, .v-collection-head, .v-footer__grid > div').forEach(node=>observer.observe(node));}
  register();
  document.addEventListener('shopify:section:load',event=>register(event.target));
  reduced.addEventListener('change',()=>{if(reduced.matches)animations.forEach(animation=>animation.cancel());});
})();
